import { render, staticRenderFns } from "./Articulo.vue?vue&type=template&id=5efe7afe&scoped=true"
import script from "./Articulo.vue?vue&type=script&lang=js"
export * from "./Articulo.vue?vue&type=script&lang=js"
import style0 from "./Articulo.vue?vue&type=style&index=0&id=5efe7afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe7afe",
  null
  
)

export default component.exports